import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { PopoverController, LoadingController, AlertController, MenuController } from '@ionic/angular';
import { ServicioService } from 'src/app/services/servicio.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {

    hasData = false;
    items: any = [];
    productos: any = [];
    productRows: any;

    cartItems: any[];
    public countCart = 0;

    searchVisible = false;

    public pais;
    public flag = '';

    constructor(
        private popoverCtrl: PopoverController,
        private loadingCtrl: LoadingController,
        private alertCtrl: AlertController,
        private service: ServicioService,
        private router: Router
    ) {

    }

    ngOnInit() {
        this.items = [];
        this.productos = [];
        this.productRows = null;
    }

    async ionViewWillEnter() {
        // this.actualizarCarro();
        await this.actualizarPais();
    }

    public async actualizarPais() {
        this.service.getVariable('pais').then(res => {
            this.pais = res;

            if (this.pais === null) {
                this.pais = 'co';
                this.service.setVariable('pais', 'co');
            }

            this.flag = '/assets/flags/' + this.pais + '.svg';
        });
    }

    // async actualizarCarro() {
    //     await this.cart.getCartItems().then((val) => {
    //         this.cartItems = val;
    //     });

    //     await this.cart.getCountItems().then((val) => {
    //         this.countCart = val;
    //     });
    // }

    // async mostrarCarro() {

    //     const popover = await this.popoverCtrl.create({
    //         component: CartPage,
    //         animated: true,
    //         translucent: true
    //     });

    //     popover.onDidDismiss().then(async res => {
    //         this.actualizarCarro();
    //     });

    //     return await popover.present();

    // }

    // async goToHome2() {
    //     this.hasData = false;
    //     // this.mostrarTienda(3);
    //     await this.router.navigateByUrl('/select/' + this.pais, { replaceUrl: true });
    // }

    async searchBar() {
        if (this.searchVisible) {
            this.searchVisible = false;
        } else {
            this.searchVisible = true;
        }
    }

    async search(searchbar) {

        if (searchbar && searchbar.key === 'Enter') {

            const loader = await this.loadingCtrl.create(
                {
                    spinner: 'bubbles',
                    message: 'Cargando...'
                });
            await loader.present().then(async () => {
                const val1 = String(searchbar.srcElement.value).toUpperCase();
                if (val1.length < 3) {
                    loader.dismiss();
                    return;
                }

                this.searchVisible = false;

                let reload = false;
                if (searchbar.srcElement.formAction.includes('selector')) {
                    reload = true;
                }

                // ADMIN
                if (val1 === 'VISOREXP') {

                    this.service.setVariable('express', 'Si');

                    const alert = await this.alertCtrl.create({
                        header: 'EXPRESS',
                        message: '¡ Ahora puedes hacer consultas de envíos EXPRESS !',
                        buttons: ['Aceptar']
                    });
                    await alert.present();
                    loader.dismiss();
                    return;
                } else {

                    // await this.actualizarPais();

                    this.pais = await this.service.getVariable('pais');

                    await this.service.getReferencia(this.pais, val1).then(async (data: any) => {
                        if (data.length !== 0) {
                            const params = {
                                id1: val1
                            }

                            await this.guardarProductos(params);

                            loader.dismiss();

                        } else {
                            loader.dismiss();
                            const alert = await this.alertCtrl.create({
                                header: 'Información',
                                message: '¡ La referencia no se encuentra !',
                                buttons: ['Aceptar']
                            });
                            await alert.present();
                        }
                    });
                }
            });
        }
    }

    onSearchCancel(searchbar) {
        this.searchVisible = false;
    }

    async guardarProductos(params: any): Promise<boolean> {

        this.pais = await this.service.getVariable('pais');

        const loader = await this.loadingCtrl.create(
            {
                spinner: 'bubbles',
                message: 'Obteniendo resultados...'
            });
        await loader.present().then(async () => {

            const respuesta = false;

            if (params !== undefined) {

                this.items = [];

                if (params.id1 !== undefined && params.id1 !== '') {
                    await this.items.push(params.id1.toUpperCase());
                }
                if (params.id2 !== undefined && params.id2 !== '') {
                    await this.items.push(params.id2.toUpperCase());
                }
                if (params.id3 !== undefined && params.id3 !== '') {
                    await this.items.push(params.id3.toUpperCase());
                }
                if (params.id4 !== undefined && params.id4 !== '') {
                    await this.items.push(params.id4.toUpperCase());
                }
                if (params.id5 !== undefined && params.id5 !== '') {
                    await this.items.push(params.id5.toUpperCase());
                }
                if (params.id6 !== undefined && params.id6 !== '') {
                    await this.items.push(params.id6.toUpperCase());
                }
                if (params.id7 !== undefined && params.id7 !== '') {
                    await this.items.push(params.id7.toUpperCase());
                }
                if (params.id8 !== undefined && params.id8 !== '') {
                    await this.items.push(params.id8.toUpperCase());
                }
                if (params.id9 !== undefined && params.id9 !== '') {
                    await this.items.push(params.id9.toUpperCase());
                }
                if (params.id10 !== undefined && params.id10 !== '') {
                    await this.items.push(params.id10.toUpperCase());
                }
                if (params.id11 !== undefined && params.id11 !== '') {
                    await this.items.push(params.id11.toUpperCase());
                }
                if (params.id12 !== undefined && params.id12 !== '') {
                    await this.items.push(params.id12.toUpperCase());
                }
                if (params.id13 !== undefined && params.id13 !== '') {
                    await this.items.push(params.id13.toUpperCase());
                }
                if (params.id14 !== undefined && params.id14 !== '') {
                    await this.items.push(params.id14.toUpperCase());
                }
                if (params.id15 !== undefined && params.id15 !== '') {
                    await this.items.push(params.id15.toUpperCase());
                }

                if (this.items.length >= 1) {

                    this.productos = [];

                    this.items.forEach(async (element: any) => {

                        await this.service.getReferencia(this.pais, element).then(async (data: any) => {

                            if (data.length !== 0) {
                                this.hasData = true;
                                const item = {
                                    parent: data[0].parent,
                                    name: data[0].name,
                                    retailPrice: data[0].retailPrice,
                                    images: data[0].images,
                                    items: data
                                }
                                this.productos.push(item);
                                if (this.items.length === 1) {
                                    this.service.setVariable('Referencia', this.productos[0].items);
                                    if (this.pais === 'co') {
                                        this.router.navigate(['producto/']);
                                    } else {
                                        this.router.navigate(['producto/' + this.pais + '/']);
                                    }
                                }

                                this.productRows = Array.from(Array(Math.ceil(this.items.length / 2)).keys());

                                await this.router.navigateByUrl('/home/');
                                await this.router.navigateByUrl('/producto/' + this.pais + '/');

                                loader.dismiss();
                                if (this.productos.length > 0) {
                                    return await this.service.setVariable('Referencia', this.productos.items).then(res => {
                                        return res;
                                    });
                                }

                            } else {
                                loader.dismiss();
                                const alert = await this.alertCtrl.create({
                                    header: 'Información',
                                    message: '¡ La referencia no se encuentra !',
                                    buttons: ['Aceptar']
                                });
                                await alert.present();
                                return false;
                            }
                        });
                    });

                } else {
                    this.hasData = false;
                    loader.dismiss();
                    return false;
                }

                // if (this.productos.length > 0) {
                //   return this.service.setVariable('Referencia', this.productos.items).then(res => {
                //     return res;
                //   });
                // }
            } else {
                loader.dismiss();
                return false;
            }

        });
        return true;
    }

}
